
import BasicPersonalDataComponent from "@/components/RegisterTest/BasicPersonalData/BasicPersonalDataComponent";
export default BasicPersonalDataComponent;
